export const gitCommit = '692051d4'
